import React from "react";
import { Flex, Box, styled } from "@acko-tech/building-blocks.ui.common";

const Wrapper = styled(Flex)<{ $fullBleedMobile?: boolean }>`
  box-sizing: border-box;
  background: white;
  padding: 16px 0px 150px;
  align-items: center;
  justify-content: center;

  @media (min-width: 768px) {
    background: #f8f7fc;
    padding: 60px 0px 150px;
    align-items: normal;
    justify-content: center;
    min-height: calc(100vh - 150px);
  }

  ${props => props.styles};

  /* After styles prop so full-bleed wins over consumer overrides (e.g. alignItems). */
  @media (max-width: 767px) {
    ${p =>
      p.$fullBleedMobile
        ? `
      display: flex;
      flex-direction: column;
      align-items: stretch;
      justify-content: flex-start;
      width: 100%;
      max-width: 100%;
      min-width: 0;
      padding-left: 0;
      padding-right: 0;
    `
        : ""}
  }
`;

const InnerWrapper = styled(Box)<{ $fullWidthMobile?: boolean }>`
  box-sizing: border-box;
  width: ${p => (p.$fullWidthMobile ? "100%" : "90%")};
  max-width: ${p => (p.$fullWidthMobile ? "100%" : "none")};
  flex-shrink: ${p => (p.$fullWidthMobile ? 0 : 1)};

  ${p => (p.$fullWidthMobile ? `align-self: stretch;` : "")}

  @media (max-width: 767px) {
    ${p =>
      p.$fullWidthMobile
        ? `
      width: 100%;
      max-width: 100%;
      min-width: 0;
      flex: 1 1 auto;
    `
        : ""}
  }

  @media (min-width: 768px) {
    display: flex;
    justify-content: space-between;
    width: ${props =>
      props && props.innerWrapperWidth ? props.innerWrapperWidth : "800px"};
    max-width: none;
    flex-shrink: 1;
    gap: 60px;
  }

  ${props => props.styles};
`;

export const CardContainer = styled(Box)`
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-width: 0;

  @media (min-width: 768px) {
    background-color: #ffffff;
    border-radius: 1rem;
    padding: 30px;
  }
`;

export const LeftContainer = styled(Box)`
  width: 25%;
  height: max-content;
  position: sticky;
  top: 50px;

  @media (max-width: 768px) {
    display: none;
  }

  ${props => props.styles};
`;

export const ContentContainer = styled(Box)`
  box-sizing: border-box;
  min-width: 0;

  @media (max-width: 767px) {
    width: 100%;
    max-width: 100%;
    flex: 1 1 auto;
  }

  @media (min-width: 768px) {
    width: ${props => (props && props.width ? props.width : "70%")};
  }

  ${props => props.styles};
`;

interface Props {
  children: any;
  forwardedRef?: any;
  styles?: any;
  clickHandler?: Function;
  innerWrapperWidth?: string;
  /** On narrow viewports, use full width instead of the default 90% centered column */
  fullWidthMobile?: boolean;
}

const HybridWrapper = ({
  children,
  forwardedRef,
  styles,
  clickHandler,
  innerWrapperWidth,
  fullWidthMobile
}: Props) => {
  return (
    <Wrapper
      $fullBleedMobile={fullWidthMobile}
      styles={styles}
      ref={forwardedRef && forwardedRef}
      onClick={() => {
        clickHandler && clickHandler();
      }}
    >
      <InnerWrapper
        $fullWidthMobile={fullWidthMobile}
        innerWrapperWidth={innerWrapperWidth}
      >
        {children}
      </InnerWrapper>
    </Wrapper>
  );
};

export default HybridWrapper;
